import React, { useState } from 'react';
import { ChevronDown, Trash2 } from 'lucide-react';
import { isColorOptionsField, isPrioritiesField, isStatusesField } from '../../data/formFieldPresets';
import './fieldOptionsPanel.css';

function normalizeHex(value) {
  const hex = String(value || '').trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(hex)) return hex.toUpperCase();
  if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
    return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`.toUpperCase();
  }
  return '#000000';
}

export default function FieldOptionsPanel({ formFields = [], selectedField = null, onChange }) {
  // Sub-department parent mapping is unused for now. Keep for restore.
  // const subDepartmentField = formFields.find((field) => field.fieldLabel === 'Sub-department');
  // const departmentField = formFields.find((field) => field.fieldLabel === 'Department');
  // const activeField = selectedField || subDepartmentField;
  const activeField = selectedField;
  const colorField = isColorOptionsField(activeField) ? activeField : null;
  // const subDepartmentOptions = useMemo(
  //   () => subDepartmentField?.options || [],
  //   [subDepartmentField?.options],
  // );
  // const departmentOptions = departmentField?.options || [];
  // const [parentMappings, setParentMappings] = useState(
  //   () => subDepartmentField?.parentMappings ?? {},
  // );
  const [open, setOpen] = useState(false);

  // const incomingParents = JSON.stringify(subDepartmentField?.parentMappings ?? {});
  // const [appliedParents, setAppliedParents] = useState(incomingParents);
  //
  // if (incomingParents !== appliedParents) {
  //   setAppliedParents(incomingParents);
  //   const incoming = JSON.parse(incomingParents);
  //   if (Object.keys(incoming).length) {
  //     setParentMappings((currentMappings) => ({
  //       ...incoming,
  //       ...currentMappings,
  //     }));
  //   }
  // }
  //
  // const nextParentMappings = Object.fromEntries(
  //   Object.entries(parentMappings).filter(([option]) => subDepartmentOptions.includes(option)),
  // );
  // if (Object.keys(parentMappings).some((option) => !subDepartmentOptions.includes(option))) {
  //   setParentMappings(nextParentMappings);
  // }
  //
  // const updateParentMapping = (option, parent) => {
  //   setParentMappings((currentMappings) => ({
  //     ...currentMappings,
  //     [option]: parent,
  //   }));
  // };
  //
  // const deleteSubDepartment = (optionToDelete) => {
  //   if (!subDepartmentField) return;
  //
  //   const updatedFields = formFields.map((field) => {
  //     if (field !== subDepartmentField) return field;
  //
  //     return {
  //       ...field,
  //       options: field.options.filter(
  //         (option) => option !== optionToDelete,
  //       ),
  //     };
  //   });
  //
  //   setParentMappings((currentMappings) => {
  //     const nextMappings = { ...currentMappings };
  //     delete nextMappings[optionToDelete];
  //     return nextMappings;
  //   });
  //
  //   onChange?.(updatedFields);
  // };

  const updateOptionColor = (option, color) => {
    if (!colorField) return;
    const hex = /^#[0-9A-Fa-f]{6}$/.test(color) ? color.toUpperCase() : color;
    onChange?.(formFields.map((field) => (
      field.id === colorField.id
        ? { ...field, optionColors: { ...field.optionColors, [option]: hex } }
        : field
    )));
  };

  const deleteFieldOption = (optionToDelete) => {
    if (!activeField) return;
    const nextColors = { ...(activeField.optionColors || {}) };
    delete nextColors[optionToDelete];
    onChange?.(formFields.map((field) => (
      field.id === activeField.id
        ? {
          ...field,
          options: (field.options || []).filter((option) => option !== optionToDelete),
          ...(isColorOptionsField(field) ? { optionColors: nextColors } : {}),
        }
        : field
    )));
  };

  const titleLabel = activeField?.fieldLabel || 'Select field';
  const description = isStatusesField(activeField)
    ? 'Manage the statuses'
    : isPrioritiesField(activeField)
      ? 'Manage your fields.'
      // : activeField?.fieldLabel === 'Sub-department'
      //   ? 'Define options and set parent.'
      : activeField
        ? 'Manage your fields.'
        : 'Select a field to edit.';

  const optionList = activeField?.options || [];
  const optionTable = (headers, rows) => (
    <div className="field-options-panel__table-wrap">
      <table className="field-options-panel__table">
        <thead>
          <tr>
            {headers.map((header) => (
              <th scope="col" key={header}>{header}</th>
            ))}
            <th scope="col" aria-label="Delete" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );

  let body = (
    <p className="field-options-panel__empty">
      {activeField ? 'No options added.' : 'Select a field to edit.'}
    </p>
  );

  if (colorField) {
    body = optionList.length ? optionTable(
      [isStatusesField(colorField) ? 'Statuses' : 'Option', 'Colors'],
      optionList.map((option) => {
        const hex = normalizeHex(colorField.optionColors?.[option]);
        return (
          <tr key={option}>
            <td>{option}</td>
            <td>
              <div className="field-options-panel__color">
                <input
                  className="field-options-panel__hex"
                  aria-label={`Color for ${option}`}
                  value={colorField.optionColors?.[option] || hex}
                  onChange={(event) => updateOptionColor(option, event.target.value)}
                />
                <label className="field-options-panel__swatch" style={{ background: hex }} title={hex}>
                  <input
                    type="color"
                    aria-label={`Pick color for ${option}`}
                    value={hex}
                    onChange={(event) => updateOptionColor(option, event.target.value)}
                  />
                </label>
              </div>
            </td>
            <td>
              <button
                className="field-options-panel__delete"
                type="button"
                aria-label={`Delete ${option}`}
                title={`Delete ${option}`}
                onClick={() => deleteFieldOption(option)}
              >
                <Trash2 size={14} strokeWidth={1.5} color="currentColor" aria-hidden="true" />
              </button>
            </td>
          </tr>
        );
      }),
    ) : (
      <p className="field-options-panel__empty">No options added.</p>
    );
  }
  /* Sub-department parent mapping UI unused for now.
  } else if (activeField && activeField.fieldLabel === 'Sub-department') {
    body = subDepartmentOptions.length ? (
      <div className="field-options-panel__table-wrap">
        <table className="field-options-panel__table">
          <thead>
            <tr>
              <th scope="col">Option label</th>
              <th scope="col">Parent</th>
              <th scope="col" aria-label="Delete" />
            </tr>
          </thead>
          <tbody>
            {subDepartmentOptions.map((option) => (
              <tr key={option}>
                <td>{option}</td>
                <td>
                  <select
                    aria-label={`Parent for ${option}`}
                    value={parentMappings[option] || ''}
                    disabled={!departmentOptions.length}
                    onChange={(event) => updateParentMapping(option, event.target.value)}
                  >
                    <option value="">
                      {departmentOptions.length ? 'Select parent' : 'No department options'}
                    </option>
                    {departmentOptions.map((department) => (
                      <option key={department} value={department}>
                        {department}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <button
                    className="field-options-panel__delete"
                    type="button"
                    aria-label={`Delete ${option}`}
                    title={`Delete ${option}`}
                    onClick={() => deleteSubDepartment(option)}
                  >
                    <Trash2 size={14} strokeWidth={1.5} color="currentColor" aria-hidden="true" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="field-options-panel__empty">No options added.</p>
    );
  }
  */
  else if (optionList.length) {
    body = optionTable(
      [isPrioritiesField(activeField) ? 'Priorities' : 'Option'],
      optionList.map((option) => (
        <tr key={option}>
          <td>{option}</td>
          <td>
            <button
              className="field-options-panel__delete"
              type="button"
              aria-label={`Delete ${option}`}
              title={`Delete ${option}`}
              onClick={() => deleteFieldOption(option)}
            >
              <Trash2 size={14} strokeWidth={1.5} color="currentColor" aria-hidden="true" />
            </button>
          </td>
        </tr>
      )),
    );
  }

  return (
    <aside
      className={`field-options-panel${open ? ' is-open' : ''}`}
      aria-label={`Options for: ${titleLabel}`}
    >
      <button
        type="button"
        className="field-options-panel__summary"
        aria-expanded={open}
        aria-controls="field-options-panel-body"
        onClick={() => setOpen((current) => !current)}
      >
        <span className="field-options-panel__summary-text">
          <span className="field-options-panel__title">
            Options for: {titleLabel}
          </span>
          <span className="field-options-panel__description">{description}</span>
        </span>
        <ChevronDown className="field-options-panel__chevron" size={16} strokeWidth={1.8} aria-hidden="true" />
      </button>

      <div id="field-options-panel-body" className="field-options-panel__body">
        {body}
      </div>
    </aside>
  );
}
